import * as tslib_1 from "tslib";
/* I44 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var instances = 0;
var CoreIconSmall = /** @class */ (function (_super) {
    tslib_1.__extends(CoreIconSmall, _super);
    function CoreIconSmall() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // we need a unique ID for each instance to keep the gradient IDs unique
        // otherwise they break as soon as there is more than one instance on the page
        _this.instanceId = instances++;
        return _this;
    }
    CoreIconSmall.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("defs", null,
                    React.createElement("linearGradient", { x1: "0%", y1: "0%", y2: "100%", id: "I44-a-" + this.instanceId },
                        React.createElement("stop", { stopColor: "#FF9647", offset: "0%" }),
                        React.createElement("stop", { stopColor: "#FC6076", offset: "100%" })),
                    React.createElement("linearGradient", { x1: "15.179%", y1: "9.302%", x2: "85.391%", y2: "88.934%", id: "I44-b-" + this.instanceId },
                        React.createElement("stop", { stopColor: "#FF8B78", offset: "0%" }),
                        React.createElement("stop", { stopColor: "#FA4A30", offset: "100%" }))),
                React.createElement("g", { transform: "translate(2 2)", fill: "none", fillRule: "evenodd" },
                    React.createElement("circle", { fill: "url(#I44-a-" + this.instanceId + ")", cx: "10", cy: "10", r: "10" }),
                    React.createElement("circle", { fill: "url(#I44-b-" + this.instanceId + ")", cx: "10", cy: "10", r: "10" }),
                    React.createElement("path", { fill: "#FFF", d: "M10.182 13.75l-3.821 2.009.73-4.255L4 8.491l4.272-.62L10.182 4l1.91 3.871 4.272.62-3.091 3.013.729 4.255z" })))));
    };
    return CoreIconSmall;
}(React.Component));
export default CoreIconSmall;
//# sourceMappingURL=CoreIconSmall.js.map